import { MemoTextarea } from "./MemoTextarea";

interface AlertMemoFieldProps {
  value: string;
  onChange: (value: string) => void;
  /** 도메인별 메모 길이 상한 */
  maxLength?: number;
  disabled?: boolean;
}

/**
 * 상태 변경 확인 모달(`AlertDialog`)의 선택 메모 입력.
 * 입력값은 상태 변경 이력에 함께 남는다 — CS·유지보수가 같은 문구를 쓴다.
 */
export function AlertMemoField({
  value,
  onChange,
  maxLength,
  disabled = false,
}: AlertMemoFieldProps) {
  return (
    <MemoTextarea
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      disabled={disabled}
      aria-label="이력에 남길 메모"
      placeholder="(선택) 필요 시, 이력에 남길 메모를 입력하세요."
      className="typo-body-2-medium text-labels-primary inset-border-input"
    />
  );
}

AlertMemoField.displayName = "AlertMemoField";
